<div class="flex flex-col bg-card overflow-hidden">
  <div
    class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div
        *ngIf="!changeTitleMode"
        class="font-bold text-md text-secondary uppercase tracking-wider"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
      >
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto">
      <button *ngIf="!readonly && !changeTitleMode" mat-icon-button (click)="fileInput.click()">
        <mat-icon
          [svgIcon]="'publish'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
        <input
          data-cy="upload-photo-input"
          style="display: none"
          type="file"
          accept="image/jpeg, image/png, image/gif, application/pdf"
          (change)="onFileSelected($event)"
          multiple
          #fileInput
        />
      </button>

      <ng-container *ngIf="canEditPanelDef">
        <button mat-icon-button type="button" *ngIf="!changeTitleMode" [matMenuTriggerFor]="listCardMenu">
          <mat-icon
            class="icon-size-20"
            [svgIcon]="'more_vert'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #listCardMenu="matMenu">
          <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Change Panel Heading
          </button>
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </mat-menu>
        <button
          class="cancel-button"
          mat-icon-button
          type="button"
          *ngIf="changeTitleMode"
          [matTooltip]="'Cancel'"
          (click)="toggleEditMode(false)"
        >
          <mat-icon
            [svgIcon]="'cancel'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon
            [svgIcon]="'save'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </ng-container>
    </div>
  </div>
  <mat-progress-bar class="loading-progress-bar" *ngIf="loading" [mode]="'indeterminate'"></mat-progress-bar>
  <div class="flex flex-col p-8">
    <ng-container *ngIf="galleryImages.length; else emptyGalleryTemplate">
      <div class="flex flex-col html-to-image-ignore-exporting">
        <gallery gallerize #photoGallery [items]="galleryImages" [dots]="true" [thumb]="false" [nav]="false"></gallery>
        <ng-container *ngIf="!changeTitleMode">
          <section class="action-buttons flex justify-between">
            <button mat-icon-button (click)="photoGallery.prev()" [matTooltip]="'Previous photo'">
              <mat-icon [svgIcon]="'chevron_left'"></mat-icon>
            </button>
            <button mat-icon-button (click)="deletePhoto(photoGallery)" [matTooltip]="'Delete active photo'">
              <mat-icon [svgIcon]="'delete'"></mat-icon>
            </button>
            <button mat-icon-button (click)="photoGallery.next()" [matTooltip]="'Next photo'">
              <mat-icon [svgIcon]="'chevron_right'"></mat-icon>
            </button>
          </section>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>

<ng-template #emptyGalleryTemplate>
  <div class="flex flex-col items-center justify-center h-full">
    <mat-icon class="icon-size-40" [svgIcon]="'image'"></mat-icon>
    <p class="text-2xl text-secondary font-medium mt-4">No images found</p>
    <p class="text-sm text-secondary mt-2">Add images to this panel to display them.</p>
  </div>
</ng-template>
